<template>
  <v-content fixed v-if="!loggedin">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login to NDLM Portal</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-img :src="images.logo" contain height="100px"></v-img>
              <v-form ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && login()">
                <v-text-field
                  prepend-icon="person"
                  name="login"
                  label="Login"
                  :rules="getRules.user"
                  type="text"
                  v-model="user"
                  required
                ></v-text-field>
                <v-text-field
                  prepend-icon="lock"
                  name="password"
                  label="Password"
                  id="password"
                  type="password"
                  v-model="pass"
                  required
                ></v-text-field>
              </v-form>
              <p class="error" v-if="errors.length">
                <b>Please correct the following error(s):</b>
                <ul>
                  <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                </ul>
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="!valid" type="submit" @click="login">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import Rules from './rules';
//#TODO use global firebase if possible
import firebase from "./firebase/firebase";
import dbStore from './db/dbStore';

export default {
  name: "App",
  async created() {
    //Get login status from store
    console.log("In created() of login view!");
    this.loggedin = this.$store.getters.get_login;
    await this.getCenters()
  },
  data: function() {
    return {
      images: {
        logo: require("@/assets/nirmaan_trans_logo.png")
      },
      users : [],
      errors : [],
      loggedin: false,
      user: "",
      pass: "",
      error: "",
      valid : false,
      dbUser: null,
      centersInfo: {}
    };
  },
  computed: {
      getRules() {
        var rulesObject = Rules.getComponentRules("Login")
        //console.log(rulesObject)
        return rulesObject
      },
      login_details: function() {
        return this.$store.getters.get_login_details;
      }
  },
  methods: {
    login: function() {
      var vm = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(vm.user, vm.pass)
        .catch(function(error) {
          // Handle Errors here.
/*           var errorCode = error.code;
 */          var errorMessage = error.message;
          vm.errors = []
          vm.errors.push(errorMessage)
        });

      //#TODO Improve the logic using async/await
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          var email = user.email
          vm.getDbUserRoleFromEmail(email)
          .then(function(role) {
            // User is signed in.
            vm.loggedin = true;
            vm._login();
            var time = Date.now();
            //console.log(email);
            //console.log(vm.centersInfo);
          
            var centerInfo = vm.centersInfo[email]
            // Not all logins are center managers.
            // Show them all batches for now.
            let center = "All Centers";
            let centerId = 0;
            
            if (centerInfo !== undefined) {
              center = centerInfo.center
              centerId = centerInfo.centerId
            }
            let payload = {user: vm.user, login_time: time, role: role, token: user.l, home: false, center: center, centerId: centerId}
            
            vm.$store.commit('_login_details',payload)
            localStorage.setItem("state", JSON.stringify(vm.$store.state));
            vm.$router.push({name: "home"});
          })
        } else {
          // User is signed out.
          // ...
        }
      });
    },

    async getDbUserRoleFromEmail(email) {
      dbStore.setCollectionName("users");
      var users = await dbStore.getItems();
      var role = this.getUserRoleFromEmail(email, users);
      return role;
    },
    
    getUserRoleFromEmail(email,users) {
      let userInfo;
      users.forEach(element => {
        userInfo = element.element
        if(userInfo.email == email) {
          userInfo = element.element;
        } 
      });
      return userInfo.role;
    },
    async getCenters() {
      var data = {}
      dbStore.setCollectionName("centers");
      this.centers = await dbStore.getItems();
      // var userDetails = this.login_details
      // var user = userDetails.user
      await this.centers.forEach(async center => {
        var centerManagerObject = center.center_manager
        var centerManagerEmail = centerManagerObject.email
        data[centerManagerEmail] = {center: center.name, centerId: center.id}
      });
      //console.log(data);
      Object.assign(this.centersInfo, data)
    },
    
    ...mapGetters(["get_login"]),
    ...mapMutations([
      // map `this._login()` to `this.$store.commit('_login')`
      "_login",
      "_login_details"
    ])
  }
};
</script>
